

import {
  Button,
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography
} from '@mui/material'

import { useAuth } from 'auth'
import { Brand, IEWarningPopup } from 'frame/components'
import { themeV5 } from 'theme/v5'

const Login = () => {
  const { loginWithRedirect } = useAuth()

  const isIE = /*@cc_on!@*/false || !!document.documentMode

  const onLogin = () =>
    loginWithRedirect({})

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingY: 6,
        paddingX: 2,
      }}
      title="Login">

      {isIE && <IEWarningPopup />}

      <Card
        sx={{
          width: '960px',
          maxWidth: '100%',
          overflow: 'unset',
          display: 'flex',
          position: 'relative',
          '& > *': {
            flexGrow: 1,
            flexBasis: '50%',
            width: '50%',
          },
          '@media (max-width: 760px)': {
            maxWidth: '400px',
          },
        }}>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: [3, 4],
            minHeight: 300,
          }}>
          <Box>
            <Box
              sx={{
                display: 'flex',
                paddingBottom: 3,
                color: themeV5.palette.white,
              }}>
              <Brand />
            </Box>
            <Typography gutterBottom variant="body1">
              <strong>Disclaimer:</strong>
              <br />
              <br />
              Please note there are possible implications to your obligations both under your finance contract/lease and the Health
              and Safety at Work Act 2015 if the servicing requirements are not completed when due.
            </Typography>
          </Box>

          <Button
            sx={{
              marginTop: 3,
              width: '100%'
            }}
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            onClick={onLogin}>
            Sign in
          </Button>

        </CardContent>
        <CardMedia
          sx={{
            position: 'relative',
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
            padding: 3,
            color: themeV5.palette.white,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            '@media (max-width: 760px)': {
              display: 'none',
            },
          }}
          image="/static/images/login-image.jpg"
          title="Toyota">
        </CardMedia>
      </Card>
    </Box>
  )
}

export default Login
